<template>
    <div class="pdf-tab-wrapper">
        
        <div class="dx-multiview dx-swipeable dx-tabpanel dx-tabpanel-tabs-position-top dx-widget dx-ribbon generic.light dx-visibility-change-handler dx-collection" role="tabpanel">
            <div class="dx-tabpanel-tabs">
                <div role="tablist" class="dx-tabs dx-tabs-scrolling-enabled dx-tabs-horizontal dx-tab-indicator-position-bottom dx-tabs-icon-position-start dx-tabs-styling-mode-primary dx-widget dx-visibility-change-handler dx-collection dx-tabs-expanded">
                    <div class="dx-tabs-wrapper">
                        <div class="dx-item dx-tab dx-tabpanel-tab dx-tab-selected" role="tab" aria-selected="true">
                            <div class="dx-item-content dx-tab-content">
                                <div class="dx-tab-text"><span class="dx-tab-text-span">{{ $t('Файл') }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="dx-tabpanel-container">
                <div class="dx-multiview-wrapper">
                    <div class="dx-multiview-item-container">
                        <div class="dx-item dx-multiview-item dx-item-selected" role="tabpanel">
                            <div class="dx-item-content dx-multiview-item-content">
                                <div class="dx-toolbar dx-widget dx-visibility-change-handler dx-collection" role="toolbar">
                                    <div class="dx-toolbar-items-container">
                                        <div class="dx-toolbar-before" role="presentation">
                                            <div class="dx-item dx-toolbar-item dx-toolbar-button dx-toolbar-item-auto-hide" @click="onDownload">
                                                <div class="dx-item-content dx-toolbar-item-content">
                                                    <div role="button" class="dx-widget dx-button dx-button-mode-text dx-button-normal dx-button-has-text dx-button-has-icon" :title="$t('Скачать')" tabindex="0">
                                                        <div class="dx-button-content">
                                                            <i class="dx-icon fa-regular fa-download"></i>
                                                            <span class="dx-button-text">{{ $t('Скачать') }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="dx-item dx-toolbar-item dx-toolbar-button dx-toolbar-item-auto-hide" @click="onPrint">
                                                <div class="dx-item-content dx-toolbar-item-content">
                                                    <div role="button" class="dx-widget dx-button dx-button-mode-text dx-button-normal dx-button-has-text dx-button-has-icon" :title="$t('Печать')" tabindex="0">
                                                        <div class="dx-button-content">
                                                            <i class="dx-icon fa-regular fa-print"></i>
                                                            <span class="dx-button-text">{{ $t('Печать') }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="richedit-action-panel">
                <div class="d-flex align-center mr-8">
                    <span class="text-body-2">{{ currentPage }} / {{ numPages }}</span>
                </div>
                <div :title="$t('Увеличить')" class="richedit-action-btn" @click="changeZoom(0.25)">
                    <i class="dx-icon fa-regular fa-plus"></i>
                </div>
                <div :title="$t('Уменьшить')" class="richedit-action-btn" @click="changeZoom(-0.25)">
                    <i class="dx-icon fa-regular fa-minus"></i>
                </div>
                <div :title="$t('Повернуть')" class="richedit-action-btn" @click="rotate(90)">
                    <i class="dx-icon fa-regular fa-rotate-right"></i>
                </div>
                <div :title="$t('Сбросить')" class="richedit-action-btn" @click="resetDefault">
                    <i class="dx-icon fa-regular fa-arrows-rotate"></i>
                </div>
                <div :title="$t('Превью')" class="richedit-action-btn" @click="showSidebar = !showSidebar">
                    <i class="dx-icon fa-regular fa-sidebar"></i>
                </div>
            </div>
        </div>

        <div class="pdf-tab-common-layout">
            
            <aside v-show="showSidebar" class="pdf-sidebar">
                <div 
                    v-for="page in numPages" 
                    :key="'thumb-'+page" 
                    :class="{'thumbnail-item': true, 'thumbnail-item-active': thumbActiveNum == page}"
                    @click="scrollToPage(page)"
                >
                    <div class="thumb-canvas-container">
                        <canvas :id="`thumb-${page}`"></canvas>
                        <div class="thumb-number">{{ page }}</div>
                    </div>
                </div>
            </aside>

            <div id="pdf-container" ref="pdfContainer">
                <div 
                    v-for="page in numPages" 
                    :key="'page-'+page" 
                    class="page-wrapper" 
                    :ref="`pageRef-${page}`"
                >
                    <canvas :id="`page-${page}`"></canvas>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import pdfjsLib from "pdfjs-dist/build/pdf";
import pdfjsWorker from "pdfjs-dist/build/pdf.worker.entry";

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

export default {
    name: "PDFViewer",
    props: {
        url: String,
        idAttach: String,
        nameAttach: String,
    },
    data() {
        return {
            pdfInstance: null,
            numPages: 0,
            scale: 1.2,
            showSidebar: true,
            thumbActiveNum: null,
            currentPage: 1,
            rotation: 0,
            defaultScale: 1.2,
        }
    },
    created() {
        this.$eventBus.$on('pdf-viewer-trigger-print', this.onPrint);
        this.$eventBus.$on('pdf-viewer-trigger-download', this.onDownload);
    },
    beforeDestroy() {
        const container = this.$refs.pdfContainer;
        if (container) {
            container.removeEventListener('scroll', this.handleScroll);
        }
        if (this.pdfInstance) this.pdfInstance.destroy();
        this.$eventBus.$off('pdf-viewer-trigger-print');
        this.$eventBus.$off('pdf-viewer-trigger-download');
    },
    watch: {
        url: {
            handler: 'initPDFViewer',
            immediate: true
        },
        //следим чтобы активнаня миниатюра в sidebar всегда была в поле зрения
        thumbActiveNum(newVal) {
            if (this.showSidebar && newVal) {
                this.$nextTick(() => {
                    const thumbEl = document.getElementById(`thumb-${newVal}`);
                    if (thumbEl) {
                        // scrollIntoView только если миниатюра не видна (настройка 'nearest')
                        thumbEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                    }
                });
            }
        }
    },
    methods: {
        async initPDFViewer() {
            if (!this.url) return;
            
            // 1. Обязательно грохаем старый инстанс, если он был, 
            // чтобы остановить текущие процессы рендеринга
            if (this.pdfInstance) {
                await this.pdfInstance.destroy();
            }

            try {
                const loadingTask = pdfjsLib.getDocument(this.url);
                this.pdfInstance = await loadingTask.promise;
                this.numPages = this.pdfInstance.numPages;

                // 2. ВСЁ делаем в одном тикe после того, как numPages обновил DOM (v-for)
                this.$nextTick(() => {
                    // ЗАПУСКАЕМ ТОЛЬКО ОДИН РАЗ
                    this.renderAllContent();
                    
                    // ВЕШАЕМ СЛУШАТЕЛЬ СКРОЛЛА
                    const container = this.$refs.pdfContainer;
                    if (container) {
                        // Сначала удалим старый на всякий случай, чтобы не дублировать
                        container.removeEventListener('scroll', this.handleScroll);
                        container.addEventListener('scroll', this.handleScroll);
                    }
                });
            } catch (ex) {
                console.error("Ошибка PDF:", ex);
            }
        },

        async renderAllContent() {
            for (let i = 1; i <= this.numPages; i++) {
                const page = await this.pdfInstance.getPage(i);
                
                // Рендерим основную страницу (большую)
                await this.renderCanvas(page, `page-${i}`, this.scale);
                
                // Рендерим миниатюру (маленькую, scale 0.2)
                await this.renderCanvas(page, `thumb-${i}`, 0.2);
            }
        },

        async renderCanvas(page, canvasId, scale) {
            const canvas = document.getElementById(canvasId);
            if (!canvas) return;
            
            const context = canvas.getContext("2d");
            
            // ВАЖНО: для версии 2.0.943 параметры передаются так:
            const viewport = page.getViewport(scale, this.rotation);
            
            // Проверка на корректность размеров
            if (viewport.width <= 0 || viewport.height <= 0) {
                console.error("Некорректный размер viewport", viewport);
                return;
            }

            canvas.height = viewport.height;
            canvas.width = viewport.width;

            const renderContext = {
                canvasContext: context,
                viewport: viewport
            };

            const renderTask = page.render(renderContext);
            await renderTask.promise;
        },

        scrollToPage(pageNumber) {
            // Берем элемент из refs и скроллим к нему
            const el = this.$refs[`pageRef-${pageNumber}`][0];
            if (el) {
                el.scrollIntoView({ behavior: 'auto' });
                this.thumbActiveNum = pageNumber;
            }
        },

        handleScroll() {
            const container = this.$refs.pdfContainer;
            if (!container) return;

            const scrollTop = container.scrollTop;
            const containerHeight = container.clientHeight;
            
            // Ищем все обертки страниц
            const pages = container.getElementsByClassName('page-wrapper');
            
            for (let i = 0; i < pages.length; i++) {
                const page = pages[i];
                // Если верхняя граница страницы дошла до середины вьюпорта — считаем её активной
                if (page.offsetTop <= scrollTop + (containerHeight / 3)) {
                    const pageNum = i + 1;
                    this.currentPage = pageNum;
                    this.thumbActiveNum = pageNum;
                }
            }
        },

        async changeZoom(delta) {
            // Новые лимиты: от 0.4 до 1.6
            const newScale = parseFloat((this.scale + delta).toFixed(2));
            
            if (newScale >= 0.4 && newScale <= 1.6) {
                this.scale = newScale;
                await this.renderAllContent();
            }
        },

        async rotate(deg) {
            this.rotation = (this.rotation + deg) % 360;
            await this.renderAllContent();
        },

        async resetDefault() {
            this.scale = this.defaultScale;
            this.rotation = 0;
            await this.renderAllContent();
        },

        onPrint() {
            const objFra = document.createElement('iframe');
            objFra.style.display = "none";
            objFra.src = this.url;
            objFra.onload = () => {
                objFra.contentWindow.focus();
                objFra.contentWindow.print();
            };
            document.body.appendChild(objFra);
        },

        onDownload() {
            this.$eventBus.$emit('on-download-file', { id: this.idAttach, name: this.nameAttach });
        }
    }
}
</script>